module.exports = __webpack_public_path__ + "b061dadc.png";